const GET_MASTER_CLASS_CARD_REQUEST = "GET_MASTER_CLASS_CARD_REQUEST";
const GET_MASTER_CLASS_CARD_COMPLETED = "GET_MASTER_CLASS_CARD_COMPLETED";
const GET_MASTER_CLASS_CARD_ERROR = "GET_MASTER_CLASS_CARD_ERROR";

const GET_MASTER_CLASS_REQUEST = "GET_MASTER_CLASS_REQUEST";
const GET_MASTER_CLASS_COMPLETED = "GET_MASTER_CLASS_COMPLETED";
const GET_MASTER_CLASS_ERROR = "GET_MASTER_CLASS_ERROR";

const GET_MASTER_CLASS_SYSTEM_INFO_REQUEST = "GET_MASTER_CLASS_SYSTEM_INFO_REQUEST";
const GET_MASTER_CLASS_SYSTEM_INFO_COMPLETED = "GET_MASTER_CLASS_SYSTEM_INFO_COMPLETED";
const GET_MASTER_CLASS_SYSTEM_INFO_ERROR = "GET_MASTER_CLASS_SYSTEM_INFO_ERROR";

const CREATE_MASTER_CLASS_REQUEST = "CREATE_MASTER_CLASS_REQUEST";
const CREATE_MASTER_CLASS_COMPLETED = "CREATE_MASTER_CLASS_COMPLETED";
const CREATE_MASTER_CLASS_ERROR = "CREATE_MASTER_CLASS_ERROR";

const UPDATE_MASTER_CLASS_REQUEST = "UPDATE_MASTER_CLASS_REQUEST";
const UPDATE_MASTER_CLASS_COMPLETED = "UPDATE_MASTER_CLASS_COMPLETED";
const UPDATE_MASTER_CLASS_ERROR = "UPDATE_MASTER_CLASS_ERROR";

const UPDATE_MASTER_CLASS_LOGO_REQUEST = "UPDATE_MASTER_CLASS_LOGO_REQUEST";
const UPDATE_MASTER_CLASS_LOGO_COMPLETED = "UPDATE_MASTER_CLASS_LOGO_COMPLETED";
const UPDATE_MASTER_CLASS_LOGO_ERROR = "UPDATE_MASTER_CLASS_LOGO_ERROR";

const UPDATE_MASTER_CLASS_FILE_REQUEST = "UPDATE_MASTER_CLASS_FILE_REQUEST";
const UPDATE_MASTER_CLASS_FILE_COMPLETED = "UPDATE_MASTER_CLASS_FILE_COMPLETED";
const UPDATE_MASTER_CLASS_FILE_ERROR = "UPDATE_MASTER_CLASS_FILE_ERROR";

const DELETE_MASTER_CLASS_REQUEST = "DELETE_MASTER_CLASS_REQUEST";
const DELETE_MASTER_CLASS_COMPLETED = "DELETE_MASTER_CLASS_COMPLETED";
const DELETE_MASTER_CLASS_ERROR = "DELETE_MASTER_CLASS_ERROR";

const DELETE_MASTER_CLASS_LOGO_REQUEST = "DELETE_MASTER_CLASS_LOGO_REQUEST";
const DELETE_MASTER_CLASS_LOGO_COMPLETED = "DELETE_MASTER_CLASS_LOGO_COMPLETED";
const DELETE_MASTER_CLASS_LOGO_ERROR = "DELETE_MASTER_CLASS_LOGO_ERROR";

const DELETE_MASTER_CLASS_FILE_REQUEST = "DELETE_MASTER_CLASS_FILE_REQUEST";
const DELETE_MASTER_CLASS_FILE_COMPLETED = "DELETE_MASTER_CLASS_FILE_COMPLETED";
const DELETE_MASTER_CLASS_FILE_ERROR = "DELETE_MASTER_CLASS_FILE_ERROR";

const CHANGE_MASTER_CLASS_STATE_REQUEST = "CHANGE_MASTER_CLASS_STATE_REQUEST";
const CHANGE_MASTER_CLASS_STATE_COMPLETE = "CHANGE_MASTER_CLASS_STATE_COMPLETE";
const CHANGE_MASTER_CLASS_STATE_ERROR = "CHANGE_MASTER_CLASS_STATE_ERROR";

const GET_MASTER_CLASS_STUDENTS_REQUEST = "GET_MASTER_CLASS_STUDENTS_REQUEST";
const GET_MASTER_CLASS_STUDENTS_COMPLETED = "GET_MASTER_CLASS_STUDENTS_COMPLETED";
const GET_MASTER_CLASS_STUDENTS_ERROR = "GET_MASTER_CLASS_STUDENTS_ERROR";

const CREATE_NEW_STUDENT_REQUEST = "CREATE_NEW_STUDENT_REQUEST";
const CREATE_NEW_STUDENT_COMPLETED = "CREATE_NEW_STUDENT_COMPLETED";
const CREATE_NEW_STUDENT_ERROR = "CREATE_NEW_STUDENT_ERROR";

const ADD_EXIST_STUDENT_REQUEST = "ADD_EXIST_STUDENT_REQUEST";
const ADD_EXIST_STUDENT_COMPLETED = "ADD_EXIST_STUDENT_COMPLETED";
const ADD_EXIST_STUDENT_ERROR = "ADD_EXIST_STUDENT_ERROR";

const DELETE_STUDENT_REQUEST = "DELETE_STUDENT_REQUEST";
const DELETE_STUDENT_COMPLETED = "DELETE_STUDENT_COMPLETED";
const DELETE_STUDENT_ERROR = "DELETE_STUDENT_ERROR";

const GET_MASTER_CLASSES_BY_PROGRAM_REQUEST = "GET_MASTER_CLASSES_BY_PROGRAM_REQUEST";
const GET_MASTER_CLASSES_BY_PROGRAM_COMPLETED = "GET_MASTER_CLASSES_BY_PROGRAM_COMPLETED";
const GET_MASTER_CLASSES_BY_PROGRAM_ERROR = "GET_MASTER_CLASSES_BY_PROGRAM_ERROR";

export  default  {
  GET_MASTER_CLASS_CARD_REQUEST,
  GET_MASTER_CLASS_CARD_COMPLETED,
  GET_MASTER_CLASS_CARD_ERROR,
  GET_MASTER_CLASS_REQUEST,
  GET_MASTER_CLASS_COMPLETED,
  GET_MASTER_CLASS_ERROR,
  GET_MASTER_CLASS_SYSTEM_INFO_REQUEST,
  GET_MASTER_CLASS_SYSTEM_INFO_COMPLETED,
  GET_MASTER_CLASS_SYSTEM_INFO_ERROR,

  CREATE_MASTER_CLASS_REQUEST,
  CREATE_MASTER_CLASS_ERROR,
  CREATE_MASTER_CLASS_COMPLETED,

  UPDATE_MASTER_CLASS_REQUEST,
  UPDATE_MASTER_CLASS_COMPLETED,
  UPDATE_MASTER_CLASS_ERROR,

  DELETE_MASTER_CLASS_REQUEST,
  DELETE_MASTER_CLASS_COMPLETED,
  DELETE_MASTER_CLASS_ERROR,

  DELETE_MASTER_CLASS_LOGO_REQUEST,
  DELETE_MASTER_CLASS_LOGO_COMPLETED,
  DELETE_MASTER_CLASS_LOGO_ERROR,

  DELETE_MASTER_CLASS_FILE_REQUEST,
  DELETE_MASTER_CLASS_FILE_COMPLETED,
  DELETE_MASTER_CLASS_FILE_ERROR,

  UPDATE_MASTER_CLASS_FILE_REQUEST,
  UPDATE_MASTER_CLASS_FILE_COMPLETED,
  UPDATE_MASTER_CLASS_FILE_ERROR,

  UPDATE_MASTER_CLASS_LOGO_REQUEST,
  UPDATE_MASTER_CLASS_LOGO_COMPLETED,
  UPDATE_MASTER_CLASS_LOGO_ERROR,

  CHANGE_MASTER_CLASS_STATE_REQUEST,
  CHANGE_MASTER_CLASS_STATE_COMPLETE,
  CHANGE_MASTER_CLASS_STATE_ERROR,

  CREATE_NEW_STUDENT_REQUEST,
  CREATE_NEW_STUDENT_COMPLETED,
  CREATE_NEW_STUDENT_ERROR,

  ADD_EXIST_STUDENT_REQUEST,
  ADD_EXIST_STUDENT_COMPLETED,
  ADD_EXIST_STUDENT_ERROR,

  DELETE_STUDENT_REQUEST,
  DELETE_STUDENT_COMPLETED,
  DELETE_STUDENT_ERROR,

  GET_MASTER_CLASS_STUDENTS_REQUEST,
  GET_MASTER_CLASS_STUDENTS_COMPLETED,
  GET_MASTER_CLASS_STUDENTS_ERROR,

  GET_MASTER_CLASSES_BY_PROGRAM_REQUEST,
  GET_MASTER_CLASSES_BY_PROGRAM_COMPLETED,
  GET_MASTER_CLASSES_BY_PROGRAM_ERROR
}
